import { ConfirmationAction } from '@app/components/ConfirmationAction';
import { useToast } from '@app/core/notifications';
import { streamerBoxStreamerBoxDeviceServicesStart } from '@mi-front/api-v2';
import { Device, Service } from '@mi-front/core';
import { useAsyncViewCtx } from '@mi-front/ui';
import { PlayArrow as PlayIcon } from '@mui/icons-material';
import { Button } from '@mui/material';
import { useIntl } from 'react-intl';

interface PropsP {
  readonly start: () => void;
  readonly disabled?: boolean;
}

/** Confirmation UI to start a streamer-box service. */
export function ServiceStartP(p: PropsP) {
  const { $t } = useIntl();
  const { notifyInfo, notifyError } = useToast();

  return (
    <ConfirmationAction
      message={$t({
        id: 'streamerBox.viewScreen.services.actions.start.prompt',
        defaultMessage: '¿Deseas realmente iniciar el servicio?',
      })}
      onConfirm={async () => {
        try {
          await p.start();
          notifyInfo(
            $t({
              id: 'streamerBox.viewScreen.services.actions.start.done',
              defaultMessage: 'Inicio de servicio solicitado',
            }),
          );
        } catch {
          notifyError(
            $t({
              id: 'streamerBox.viewScreen.services.actions.start.error',
              defaultMessage: 'No se pudo iniciar el servicio',
            }),
          );
        }
      }}
    >
      {({ onClick }) => (
        <Button
          size="small"
          variant="outlined"
          color="primary"
          disabled={p.disabled}
          onClick={onClick}
          startIcon={<PlayIcon />}
        >
          {$t({
            id: 'streamerBox.viewScreen.services.actions.start.btn',
            defaultMessage: 'Iniciar',
          })}
        </Button>
      )}
    </ConfirmationAction>
  );
}

interface Props {
  readonly device: Device;
  readonly service: Service;
}

/** Starts a streamer-box service and reloads the parent AsyncView. */
export function ServiceStart(p: Props) {
  const { device, service } = p;
  const { reload } = useAsyncViewCtx();

  return (
    <ServiceStartP
      start={async () => {
        await streamerBoxStreamerBoxDeviceServicesStart(String(device.id), service.imageId);
        reload();
      }}
      disabled={service.status !== 'Stopped'}
    />
  );
}
